import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VRow,[_c(VCol,[_c(VDataTable,{staticClass:"elevation-1 w-100 proposta h-100",attrs:{"headers":_vm.headersValores,"items":_vm.itemValores,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.investimentoTotal",fn:function({ item }){return [_vm._v("\n          "+_vm._s(item.investimentoTotal &&
            item.investimentoTotal.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }))+"\n        ")]}},{key:"item.contrapartidaSebrae",fn:function({ item }){return [_vm._v("\n          "+_vm._s(item.contrapartidaSebrae &&
            item.contrapartidaSebrae.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }))+"\n        ")]}},{key:"item.investimentoMunicipal",fn:function({ item }){return [_vm._v("\n          "+_vm._s(item.investimentoMunicipal &&
            item.investimentoMunicipal.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            }))+"\n        ")]}}])})],1)],1),(_vm.ultrapassouValorTeto)?_c(VRow,[_c(VCol,[_c('div',[_c('strong',[_vm._v("\n          O investimento total sem soluções extras ultrapassou o investimento\n          do teto, valores sem subsídio são pagos integralmente pelo\n          município.\n        ")])])])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }